module.exports = __webpack_public_path__ + "img/illustration-10.cf4fdab6.png";